import React from 'react';

export default function GrievanceOfficer() {
  return (
    <div className="page">
      <div className="container" style={{ maxWidth: '860px', padding: '3rem 2rem' }}>
        <div className="page-header">
          <h1>Grievance Officer</h1>
          <p>Last updated: May 27, 2026</p>
        </div>

        <div className="static-content">
          <section>
            <h2>Grievance Redressal Mechanism</h2>
            <p>
              In accordance with the Information Technology Act, 2000, the Information Technology
              (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021, and the Consumer
              Protection Act, 2019, we have appointed a Grievance Officer to address your concerns.
            </p>
          </section>

          <section>
            <h2>Grievance Officer Details</h2>
            <div style={{ padding: '1.5rem', background: 'rgba(255,255,255,0.04)', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.08)' }}>
              <p><strong>Name:</strong> AstroA2Z Grievance Cell</p>
              <p><strong>Designation:</strong> Grievance Officer</p>
              <p><strong>Email:</strong> <a href="mailto:grievance@astroa2z.com">grievance@astroa2z.com</a></p>
              <p><strong>Address:</strong> Hyderabad, Telangana, India</p>
              <p><strong>Working Hours:</strong> Monday to Friday, 10:00 AM – 6:00 PM IST</p>
            </div>
          </section>

          <section>
            <h2>How to File a Grievance</h2>
            <ol>
              <li>Send an email to <a href="mailto:grievance@astroa2z.com">grievance@astroa2z.com</a> with
                the subject line "Grievance — [Brief Description]"</li>
              <li>Include your registered email address, account details (if applicable), and a clear
                description of the issue</li>
              <li>Attach any supporting documents or screenshots if relevant</li>
              <li>You will receive an acknowledgment within <strong>24 hours</strong> of receipt</li>
            </ol>
          </section>

          <section>
            <h2>Resolution Timeline</h2>
            <ul>
              <li><strong>Acknowledgment:</strong> Within 24 hours of receiving the grievance</li>
              <li><strong>Resolution:</strong> Within 15 days from the date of receipt of the grievance</li>
              <li>If additional time is required, we will inform you with a revised timeline and reason</li>
            </ul>
          </section>

          <section>
            <h2>Types of Grievances Handled</h2>
            <ul>
              <li>Data privacy concerns and DPDP Act requests</li>
              <li>Account-related issues (unauthorized access, deletion requests)</li>
              <li>Content-related complaints (objectionable or inaccurate content)</li>
              <li>Payment and refund disputes</li>
              <li>Service quality concerns</li>
              <li>Intellectual property infringement claims</li>
              <li>Harassment or abuse by other users or priests</li>
            </ul>
          </section>

          <section>
            <h2>Escalation</h2>
            <p>
              If you are not satisfied with the resolution provided by our Grievance Officer, you may:
            </p>
            <ul>
              <li>Escalate to our management at <a href="mailto:legal@astroa2z.com">legal@astroa2z.com</a></li>
              <li>File a complaint with the Data Protection Board of India (for data-related grievances)</li>
              <li>Approach the Consumer Disputes Redressal Forum under the Consumer Protection Act, 2019</li>
              <li>Approach the competent courts in Hyderabad, Telangana, India</li>
            </ul>
          </section>

          <section>
            <h2>Data Protection Officer</h2>
            <p>
              For matters specifically related to personal data processing, privacy rights, and
              DPDP Act compliance, contact our Data Protection Officer:
            </p>
            <p>
              <strong>Email:</strong> <a href="mailto:dpo@astroa2z.com">dpo@astroa2z.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
